import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Offcanvas', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Offcanvas', element, config);
}

function toggle(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.toggle('Offcanvas', element, config);
}

// ----------------------------------------------------------------------------

export { show, hide, toggle };
